import React, { useEffect, useState } from "react";
import CustomForm from "@sistemas.mundo/custom-form";
import useValidarRut from "../../../../queries/login/useValidarRut";

const ValidarRut = ({ rutVerificado, setRutVerificado }) => {
  const [tokenCaptcha, setTokenCaptcha] = useState(null);
  //query
  const queryValidarRut = useValidarRut();

  const onSubmit = (data) => {
    queryValidarRut.mutate({
      clie_rut: data.RutCliente,
      clie_num_serie: data.numeroDocumento,
      token_captcha: tokenCaptcha,
    });
  };

  const onSuccess = (token) => {
    setTokenCaptcha(token);
  };
  const onExpired = () => {
    setTokenCaptcha(null);
  };

  useEffect(() => {
    if (queryValidarRut.isSuccess) {
      setRutVerificado(true);
    }
  }, [queryValidarRut.isSuccess]);

  const camposFormulario = () => {
    return [
      {
        title: "",
        elements: [
          {
            name: "RutCliente",
            label: "RUT",
            placeholder: "12345678-9",
            value: null,
            type: "rut",
            required: true,
            visible: true,
            disabled: rutVerificado,
            onChange: null,
            customValidation: null,
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "numeroDocumento",
            label: "Número de documento",
            placeholder: "111.000.111",
            value: null,
            type: "text",
            required: true,
            visible: true,
            disabled: rutVerificado,
            onChange: null,
            customValidation: null,
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
          {
            name: "recaptcha",
            label: "reCAPTCHA",
            value: null,
            type: "recaptcha",
            keyRecaptcha: "6LdRU8woAAAAAIPZLtfJeId4jpXHNi-hfQpbK39k",
            onSuccesscaptcha: onSuccess,
            onExpiredcaptcha: onExpired,
            token: tokenCaptcha,
            required: true,
            visible: !rutVerificado,
            onChange: null,
            customValidation: null,
            customFormat: null,
            grid: {
              xs: 12,
              md: 12,
              lg: 12,
              xl: 12,
            },
          },
        ],
      },
    ];
  };

  return (
    <CustomForm
      formId="formulario_login"
      campos={camposFormulario()}
      showClearForm={false}
      showSubmitBtn={!rutVerificado}
      onSubmit={onSubmit}
      submitButtonText={"Recuperar"}
      tooltipSubmitBtn={"Recuperar"}
      submitButtonPosition="center"
      fullButtonSubmitWidth={true}
      resetCamposOnSubmit={false}
    />
  );
};

export default ValidarRut;
